import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AppComponent } from './app.component';
import { mainComponent } from './Components/main/main.component';
import { LedFaded } from './Components/LedFaded/LedFaded.component';
import { LedStatic } from './Components/LedStatic/LedStatic.component';
import {
  routing,
  appRoutingProviders
} from './app.routing';

@NgModule({
  declarations: [
    AppComponent,
    mainComponent,
    LedFaded,
    LedStatic
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    routing
  ],
  providers: [
    appRoutingProviders
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.module.ts
 **/